import styled from "styled-components";

export const Page = styled.div`
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #f7f9fc;
  color: #1b2028;
  font-family: "Manrope", sans-serif;
`;

export const Header = styled.div`
  padding: 24px 32px 16px;
  border-bottom: 1px solid #e3e8ef;
  background: #fff;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  margin: 4px 0 16px;
  color: #66758a;
  font-size: 14px;
`;

export const SearchWrap = styled.div`
  position: relative;
  max-width: 640px;
`;

export const Results = styled.div`
  position: absolute;
  z-index: 20;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  max-height: 420px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dde2e9;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.14);
`;

export const ResultRow = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid #f0f3f7;
  background: ${({ $active }) => ($active ? "#f2f6fd" : "#fff")};
  cursor: pointer;
  font-family: inherit;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f2f6fd;
  }
`;

export const ResultTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1b2028;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
`;

export const ResultSection = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #8494a8;
  flex-shrink: 0;
`;

export const ResultSnippet = styled.div`
  margin-top: 3px;
  font-size: 13px;
  line-height: 19px;
  color: #66758a;

  mark {
    background: #fff1b8;
    color: inherit;
    padding: 0 1px;
    border-radius: 2px;
  }
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
`;

export const Nav = styled.nav`
  width: 280px;
  flex-shrink: 0;
  overflow-y: auto;
  padding: 20px 12px 40px;
  border-right: 1px solid #e3e8ef;
  background: #fff;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const NavSection = styled.div`
  margin-bottom: 20px;
`;

export const NavSectionTitle = styled.div`
  padding: 0 12px 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8494a8;
`;

export const NavItem = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 7px 12px;
  border: none;
  border-radius: 6px;
  background: ${({ $active }) => ($active ? "#eaf1fd" : "transparent")};
  color: ${({ $active }) => ($active ? "#0C53BB" : "#41506a")};
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  font-size: 13.5px;
  line-height: 19px;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    background: ${({ $active }) => ($active ? "#eaf1fd" : "#f2f5f9")};
  }
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 28px 40px 64px;
`;

export const Article = styled.article`
  max-width: 780px;
`;

export const Breadcrumb = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #8494a8;
  margin-bottom: 8px;
`;

export const ArticleSummary = styled.p`
  margin: 0 0 24px;
  font-size: 15px;
  line-height: 23px;
  color: #66758a;
  padding-bottom: 20px;
  border-bottom: 1px solid #e3e8ef;
`;

export const Pager = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e3e8ef;
`;

export const PagerLink = styled.button`
  flex: 1;
  text-align: ${({ $next }) => ($next ? "right" : "left")};
  padding: 12px 16px;
  border: 1px solid #dde2e9;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    border-color: #0c53bb;
  }
`;

export const PagerLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8494a8;
`;

export const PagerTitle = styled.div`
  margin-top: 2px;
  font-size: 14px;
  font-weight: 600;
  color: #1b2028;
`;

export const Landing = styled.div`
  max-width: 900px;
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 8px;
`;

export const Card = styled.div`
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  padding: 18px 20px;
`;

export const CardTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 700;
`;

export const CardLink = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 5px 0;
  border: none;
  background: none;
  color: #0c53bb;
  font-size: 13.5px;
  line-height: 19px;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const Centered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 0;
`;
